var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "subscribers-wrap" },
    [
      !_vm.isLoadingData && _vm.getTenants.length < 1
        ? [
            _c("div", { staticClass: "no-results text-center" }, [
              _vm._v("No Subscribers detected!"),
            ]),
          ]
        : [
            _c(
              "div",
              [
                _c(
                  "v-expansion-panels",
                  {
                    attrs: {
                      popout: "",
                      multiple: "",
                      focusable: "",
                      "active-class": "active",
                    },
                  },
                  _vm._l(_vm.getTenants, function (subItem, subIndex) {
                    return _c(
                      "v-expansion-panel",
                      {
                        key: `channel-type-tenant-key-${subIndex}`,
                        attrs: {
                          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                          title: "Item",
                        },
                      },
                      [
                        _c(
                          "v-expansion-panel-header",
                          {
                            staticClass: "list-root",
                            attrs: {
                              title: `${
                                subItem.subscribers.length > 0
                                  ? subItem.subscribers.length
                                  : "no"
                              } subscribers`,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "channel-type-tenant-header",
                                style: {
                                  opacity:
                                    subItem.subscribers.length < 1 ? 0.5 : 1,
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  { staticClass: "mr-2", attrs: { small: "" } },
                                  [_vm._v("fas fa-user")]
                                ),
                                _vm._v(" " + _vm._s(subItem.name) + " "),
                                subItem.subscribers.length > 0
                                  ? _c("subscriber-count", {
                                      attrs: {
                                        count: subItem.subscribers.length,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "v-expansion-panel-content",
                          [
                            !!subItem.subscribers &&
                            subItem.subscribers.length > 0
                              ? _vm._l(
                                  subItem.subscribers,
                                  function (subscriberItem) {
                                    return _c("subscriber-entry", {
                                      key: `subscriber-entry-key-${subscriberItem.id}`,
                                      attrs: {
                                        subscriber: subscriberItem,
                                        "action-edit": "",
                                      },
                                      on: {
                                        delete: _vm.deleteChannelConfirmation,
                                        edit: _vm.showSubscriberEditorHandler,
                                      },
                                    })
                                  }
                                )
                              : [
                                  _c("div", { staticClass: "no-results" }, [
                                    _vm._v(" no subscribers detected "),
                                  ]),
                                ],
                            _c(
                              "div",
                              {
                                staticClass: "add-subscription-clickable",
                                class: _vm.$vuetify.theme.dark
                                  ? "dark"
                                  : "light",
                                on: {
                                  click: function ($event) {
                                    return _vm.addSubscriberHandler({
                                      text: subItem.name,
                                      value: subItem.id,
                                    })
                                  },
                                },
                              },
                              [_vm._v(" + add ")]
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ],
      _c(
        "div",
        {
          staticClass: "add-subscriber-clickable",
          class: _vm.$vuetify.theme.dark ? "dark" : "light",
          on: {
            click: function ($event) {
              return _vm.showSubscriberEditorHandler(null)
            },
          },
        },
        [_vm._v(" + add ")]
      ),
      _c("subscriber-editor", {
        attrs: {
          show: _vm.showEditor,
          saving: _vm.saving,
          subscriber: _vm.selectedSubscriber,
          tenantsList: _vm.getTenants,
          "preselected-tenant": _vm.preselectedTenant,
          "channel-type-tenant-list": _vm.channelTypeTenantList,
          channelTypes: _vm.getChannelTypes,
        },
        on: { close: _vm.closeEditorHandler, save: _vm.saveChannel },
      }),
      !!_vm.deleteChannelData &&
      !!_vm.deleteChannelData.channel &&
      !!_vm.deleteChannelData.channel.description
        ? _c(
            "v-dialog",
            {
              model: {
                value: _vm.showConfirmation,
                callback: function ($$v) {
                  _vm.showConfirmation = $$v
                },
                expression: "showConfirmation",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "confirmation-card" },
                [
                  _c("v-card-title", [
                    _vm._v(
                      " " +
                        _vm._s(
                          `Delete Channel "${_vm.deleteChannelData.channel.description}"`
                        ) +
                        " "
                    ),
                  ]),
                  _vm.deleteChannelData.affectedSubscriptionGroups.length > 0
                    ? _c("v-card-text", { staticClass: "mt-2" }, [
                        _c(
                          "div",
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "mb-1 mr-1",
                                attrs: { "x-small": "", color: "amber" },
                              },
                              [_vm._v("fas fa-exclamation-triangle")]
                            ),
                            _vm._v(
                              " Can not delete this Channel. This channel is already assigned to the subscription groups: "
                            ),
                          ],
                          1
                        ),
                        _c("div", [
                          _c(
                            "ul",
                            _vm._l(
                              _vm.deleteChannelData.affectedSubscriptionGroups,
                              function (groupItem) {
                                return _c(
                                  "li",
                                  {
                                    key: `affected-subscription-group-key-${groupItem.id}`,
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          `${groupItem.tenant.name} - ${groupItem.name}`
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "" },
                          on: { click: _vm.cancelChannelDeletionHandler },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "error",
                            disabled:
                              _vm.deleteChannelData.affectedSubscriptionGroups
                                .length > 0,
                          },
                          on: { click: _vm.deleteChannel },
                        },
                        [_vm._v("Delete ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }